import React from "react"
import propTypes from "prop-types"

import Header from "../../components/Header"
import Footer from "../../components/Footer"

const Default = ({ title, description }) => {
  return (
    <div className="main-container main-container--light">
      <Header theme="dark" hideNotifications />

      <div className="content">
        <div className="content_section_header">
          <div className="container">
            <div className="row">
              <div className="col-md-10 offset-md-1">
                <h1 className="content_section_title">{title}</h1>
                <div className="content_section_description wysiwyg">
                  {description}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

Default.propTypes = {
  title: propTypes.string.isRequired,
  description: propTypes.oneOfType([propTypes.string, propTypes.object])
    .isRequired
}

export default Default
